import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { StatusTable } from '../src/components/status';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    {/* Link will be available once https://github.com/primer/design/pull/354 merges */}
    <p>{`Check out the `}<a parentName="p" {...{
        "href": "/guides/contribute/component-lifecycle"
      }}>{`component lifecycle`}</a>{` for more information on each status.`}</p>
    <StatusTable mdxType="StatusTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      